import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DataGridTable({
  studentList,
  appliedUniversities,
  appliedTimelines,
  appliedTerms,
  appliedUnit,
  appliedTeacher,
  appliedPrograms,
}) {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleRowClick = (params) => {
    // Navigate to the detail page, using the sno as a parameter
    navigate(`/individualteacher/studentDetails`, {
      state: {
        StudentName: params.row.StudentName,
        shealth:params.row.shealth,
        Studentid: params.row.id,
        appliedUniversities: appliedUniversities,
        appliedTimelines: appliedTimelines,
        appliedTerms: appliedTerms,
        appliedUnit: appliedUnit,
        appliedTeacher: appliedTeacher,
        appliedPrograms: appliedPrograms,
      },
    }); // Pass the student ID if needed
  };

  //   {
  //   field: 'sno',
  //   headerName: 'S.No',
  //   width: 100,
  //   headerAlign: 'center',
  //   align: 'center',
  //   sortable: false,
  //   renderCell: (params) => {
  //     const visibleSortedIds = params.api.getSortedRowIds();
  //     const rowIndex = visibleSortedIds.indexOf(params.id);
  //     return rowIndex !== -1 ? rowIndex + 1 : '';
  //   },
  // },
  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      sortable: false, // Prevent sorting on S.No
      renderCell: (params) => params.value,
    },
    // { field: 'id', headerName: 'id', width: 0, hide: true },
    {
      field: 'StudentName',
      headerName: 'Student Name',
      width: 200,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 200,
      headerAlign: 'center',
      align: 'center',
    },
    // { field: 'shealth', headerName: 'Student Health', width: 200, header:'center' },
    {
      field: 'shealth',
      headerName: 'Student Health',
      width: 200,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const order = [
          'Extremely Behind Track',
          'Behind Track',
          'On Track',
          'Ahead of Track',
          'N/A',
        ];
        return order.indexOf(v1) - order.indexOf(v2);
      },
    },
    {
      field: 'last_engagement',
      headerName: 'Last Engagement Date',
      width: 200,
      align: 'center',
      header: 'center',
      sortComparator: (v1, v2) => {
        const d1 = new Date(v1);
        const d2 = new Date(v2);
        return d1 - d2;
      },
    },
    {
      field: 'engagementactivity',
      headerName: 'Last Engagement Activity',
      width: 200,
      align: 'center',
      header: 'center',
    },
    {
      field: 'last_outreach',
      headerName: 'Last Outreach Date',
      width: 200,
      align: 'center',
      header: 'center',
      sortComparator: (v1, v2) => {
        const d1 = new Date(v1);
        const d2 = new Date(v2);
        return d1 - d2;
      },
    },
    {
      field: 'outreach_activity',
      headerName: 'Last Outreach Activity',
      width: 200,
      align: 'center',
      header: 'center',
    },
  ];

  const rows = (studentList || []).map((item, index) => ({
    id: item.student,
    sno: index + 1, // Set sno as index + 2 directly here
    StudentName: item.full_name,
    Status: item.status,
    shealth: item.student_health,
    last_engagement: item.last_engagement,
    engagementactivity: item.engagement_activity,
    last_outreach: item.last_outreach,
    outreach_activity: item.outreach_activity,
  }));

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Starts at the first page
    pageSize: 20, // Shows 20 rows by default
  });
  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        localeText={{ noRowsLabel: 'No Students available' }}
        rowCount={rows.length} // Ensure correct total row count
        pageSizeOptions={[20, 50, 100]} // Available page sizes
        onRowClick={handleRowClick}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
    </div>
  );
}
